//(function () {
//    'use strict';

//    angular.module("imApp").factory("bulkMailsService", [function () {
//        let service = {};

//        return service;
//    }]);
//})();
